const CptName = 'ComCardPlaceholder'

export default {
  install (Vue) {
    Vue.component(CptName, require('./index.vue').default)
  }
}